/**
 * Registers a new block provided a unique name and an object defining its behavior.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
// import { registerBlockType } from '@wordpress/blocks';
const { __ } = wp.i18n; // Import __() from wp.i18n
const { registerBlockType } = wp.blocks; // Import registerBlockType() from wp.blocks
const { InspectorControls } = wp.blockEditor;
const {
  SelectControl,
  PanelBody,
  PanelRow,
  Placeholder,
  FormTokenField,
  RangeControl,
} = wp.components;
const { withSelect } = wp.data;
const { serverSideRender: ServerSideRender } = wp;
const { createElement: el } = wp.element;
// https://github.com/dgwyer/server-side-render-x
import { ServerSideRenderX } from '../../apidae-archive-block/src/server-side-render-x';

/**
 * Internal dependencies
 */
 import store from '../../../store';
import icons from "../../../icons.js";

/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
registerBlockType( 'wp-apidae/entities-category', {
	// Block name. Block names must be string that contains a namespace prefix. Example: my-plugin/my-custom-block.
  title: __("Fiches par catégorie", "wp-apidae"), // Block title.
  icon: icons.archive, // Block icon from Dashicons → https://developer.wordpress.org/resource/dashicons/.
  description: __("Affiche un ensemble de fiches. Ce bloc est déprécié, Nous vous invitons à utiliser le nouveau système de bloc et modèles", "wp-apidae"),
  keywords: [
    __("apidae fiche", "wp-apidae"),
    __("apidae", "wp-apidae"),
  ],
  supports: {
    align: true,
  },
  example: {
    attributes: {
      types: "",
    },
  },
	attributes: {
    post_type: {
      type: "string",
      default: "any",
    },
		taxonomy: {
      type: "array",
      default: [],
    },
		terms: {
      type: "array",
      default: [],
    },
		terms_operator: {
      type: "string",
      default: "IN",
    },
		limit: {
      type: "number",
      default: 3,
    },
		orderby: {
      type: "string",
      default: "title",
    },
		order: {
      type: "string",
      default: "ASC",
    },
    template: {
      type: "string",
      default: "",
    },
	},
	/**
	 * @see ./edit.js
	 */
	edit: ({ attributes, setAttributes }) => {
		const { post_type, taxonomy, terms, terms_operator, limit, orderby, order, template} = attributes;
    /**
     * Set Apidae Post Types
     */
		 function onChangeCardsTemplates(value) {
      setAttributes({ template: value });
		}

		/**
     * Select Apidae Post Types.
     */
		 const cards_templates_select = withSelect((select) => {
      const { isResolving } = select("core/data");
      return {
        cardsTemplatesData: select("wpdae/data").getCardsTemplatesList(),
        isRequesting: isResolving("wpdae/data", "getCardsTemplatesList", []),
      };
    })((props) => {
      if (props.isRequesting) {
        // still resolving; so display a "loading" indicator
        return el("div", null, "Chargement des templates...");
      }

      const cards_templates_list = [{ value: "", label: "Template personnalisé" }];
      for (const [key, value] of Object.entries(props.cardsTemplatesData)) {
        cards_templates_list.push({value: key, label: key});
      }

      return (
        <SelectControl
          onChange={onChangeCardsTemplates}
          value={template}
          label={__("Choisir un template", "wp-apidae")}
          options={cards_templates_list}
        />
      );
		});

		/**
     * Set Apidae Post Types
     */
		 function onChangePostType(value) {
      setAttributes({ post_type: value });
		}

		/**
     * Select Apidae Post Types.
     */
		 const post_types_select = withSelect((select) => {
      const { isResolving } = select("core/data");
      return {
        postTypeData: select("wpdae/data").getApidaePostTypeList(),
        isRequesting: isResolving("wpdae/data", "getApidaePostTypeList", []),
      };
    })((props) => {
      if (props.isRequesting) {
        // still resolving; so display a "loading" indicator
        return el("div", null, "Chargement des types de post...");
      }

      const post_types_list = [{ value: "any", label: "Tous les types de post" }];
      for (const [key, value] of Object.entries(props.postTypeData)) {
        post_types_list.push({value: value.name, label: value.label});
      }

      return (
        <SelectControl
          onChange={onChangePostType}
          value={post_type}
          label={__("Choisir un type de post", "wp-apidae")}
          options={post_types_list}
        />
      );
		});

		/**
     * Taxonomies
     */
		 const TaxoFilter = withSelect((select) => {
      const { isResolving } = select("core/data");
      return {
        taxonomies: select("core").getTaxonomies({ per_page: -1 }),
        isRequesting: isResolving("core", "getTaxonomies",{ per_page: -1 }),
      };
    })((props) => {
      if (props.isRequesting) {
        // still resolving; so display a "loading" indicator
        return el("div", null, "Chargement des taxinomies...");
      } else {
        let taxoNames = [];
        let taxosFieldValue = [];

        taxoNames = props.taxonomies.map( (taxo) => taxo.name );
        taxosFieldValue = taxonomy.map( ( taxoID ) => {
          let wantedTaxo = props.taxonomies.find( ( taxo ) => {
            return taxo.slug === taxoID;
          } );
          if ( wantedTaxo === undefined || ! wantedTaxo ) {
            return false;
          }
          return wantedTaxo.name;
        } );
        return (
          <FormTokenField
            value={taxosFieldValue}
            suggestions={taxoNames}
            onChange={ ( taxonomy ) => {
              let selectedTaxosArray = [];
              taxonomy.map(
                ( taxoName ) => {
                  const matchingTaxo = props.taxonomies.find( ( taxo ) => {
                    return taxo.name === taxoName;
                  } );
                  if ( matchingTaxo !== undefined ) {
                    selectedTaxosArray.push( matchingTaxo.slug )
                  }
                }
              )
              setAttributes( { taxonomy: selectedTaxosArray } );
            } }
            placeholder={__("Ajouter une taxinomie", "wp-apidae")}
            label={__(
              "Taxinomie",
              "wp-apidae"
            )}
						maxLength={1}
          />
        );
      }
		});


		/**
     * terms
     */
		const TermsFilter = withSelect((select) => {
      const { isResolving } = select("core/data");
      return {
        terms: select("core").getEntityRecords(
          "taxonomy",
          attributes.taxonomy[0],
          { per_page: 100 }
        ),
        isRequesting: isResolving("core", "getEntityRecords",[
          "taxonomy",
          attributes.taxonomy[0],
          { per_page: 100 }
        ]),
      };
    })((props) => {
      if (props.isRequesting) {
        // still resolving; so display a "loading" indicator
        return el("div", null, "Chargement des termes...");
      } else {
        if ( null === props.terms || props.terms.length === 0 ) {
          return el("div", null, "Pas de termes disponibles");;
        }
        let termNames = [];
        let termsFieldValue = [];

        termNames = props.terms.map( (term) => term.name );
        termsFieldValue = terms.map( ( termID ) => {
          let wantedTerm = props.terms.find( ( term ) => {
            return term.slug === termID;
          } );
          if ( wantedTerm === undefined || ! wantedTerm ) {
            return false;
          }
          return wantedTerm.name;
        } );
        /*const terms_list = [];
        if ( props.terms !== null ) {
          props.terms.forEach((element) => {
						terms_list.push(element.slug);
          });
        }*/
        return (
          <PanelRow>
          <FormTokenField
            value={termsFieldValue}
            suggestions={termNames}
            onChange={ ( terms ) => {
              let selectedTermsArray = [];
              terms.map(
                ( termName ) => {
                  const matchingTerm = props.terms.find( ( term ) => {
                    return term.name === termName;
                  } );
                  if ( matchingTerm !== undefined ) {
                    selectedTermsArray.push( matchingTerm.slug )
                  }
                }
              )
              setAttributes( { terms: selectedTermsArray } );
            } }
            placeholder={__("Ajouter un terme", "wp-apidae")}
            label={__(
              "Termes",
              "wp-apidae"
            )}
          />
          </PanelRow>
        );
      }
		});

    /**
     * Define terms_operator
     */
		 function onChangeTermsOperator(value) {
      setAttributes({ terms_operator: value });
    }

    /**
     * Define orderby
     */
		 function onChangeOrderBy(value) {
      setAttributes({ orderby: value });
    }
    /**
     * Define order
     */
		 function onChangeOrder(value) {
      setAttributes({ order: value });
    }

    /**
		 * Set limit
		 */
		function onChangelimit( value ) {
			setAttributes( { limit: value } )
		}

    function ShowPlaceHolder(){
        return (
          <ServerSideRenderX
            block="wp-apidae/entities-category"
            attributes={{
              post_type: post_type,
              taxonomy: taxonomy,
              terms: terms,
              terms_operator: terms_operator,
              limit: limit,
              orderby: orderby,
              order: order,
              template: template
            }}
            spinnerLocation={{right: 0, top: 10, unit: 'px'}}
          />
        );
    }

		/**
		 * Return
		 */
		 return ([
			<InspectorControls key="inspector">
				<PanelBody title="Configuration">
					<PanelRow>
						{el(post_types_select)}
          </PanelRow>
          <PanelRow>
          <RangeControl
              label='Nombre de fiches'
							value={limit}
							onChange={onChangelimit}
							min={0}
							max={100}
              marks = {[{value:0,label:'Toutes'}]}
						/>
          </PanelRow>
					<PanelRow>
          {el(TaxoFilter)}
					</PanelRow>
          {el(TermsFilter)}
          { terms.length !== 0 &&
            <PanelRow>
            <SelectControl
              onChange={onChangeTermsOperator}
              value={terms_operator}
              label={__("Opérateur", "wp-apidae")}
              options={[{value:'IN',label:'IN'},{value:'NOT IN',label:'NOT IN'},{value:'AND',label:'AND'}]}
            />
            </PanelRow>
          }
            <PanelRow>
            <SelectControl
              onChange={onChangeOrderBy}
              value={orderby}
              label={__("Ordre", "wp-apidae")}
              options={[{value:'title',label:'Titre'},{value:'rand',label:'Aléatoire'}]}
            />
            </PanelRow>
            <PanelRow>
            <SelectControl
              onChange={onChangeOrder}
              value={order}
              label={__("Sens d'affichage", "wp-apidae")}
              options={[{value:'ASC',label:'ASC'},{value:'DESC',label:'DESC'}]}
            />
            </PanelRow>
          <PanelRow>
            {el(cards_templates_select)}
          </PanelRow>
				</PanelBody>
			</InspectorControls>,
      ShowPlaceHolder()
		 ]);
	},

	/**
	 * 
	 */
	 save: () => {
    return null;
  },
} );
